import React from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as AcceptedSVG } from '../../../assets/icon-success-green.svg'
import { ReactComponent as DeclinedSVG } from '../../../assets/icon-decline-red.svg'
import { ReactComponent as InfoSVG } from '../../../assets/icon-info-blue.svg'
import Card from '../card'
import { FeedStatusSC, NoteSC } from './feed-status.styled'

interface IFeedStatusProps {
  createdAt: string
  statusType:
    | 'approval'
    | 'activation'
    | 'etermin'
    | 'runningPeriodAssigned'
    | 'stepStart'
    | 'stepEnd'
  approved?: boolean
  hasEtermin?: boolean
  note?: string
}

const FeedStatus: React.FC<IFeedStatusProps> = (props) => {
  const { statusType, createdAt } = props
  const { t } = useTranslation()
  let textContent
  let svg
  let note

  switch (statusType) {
    // TODO ?? USED
    case 'activation':
      textContent = t('feedStatus.patientActivated')
      svg = <InfoSVG />
      break
    case 'approval':
      if ('approved' in props) {
        if (props.approved) {
          textContent = t('feedStatus.patientAccepted')
          svg = <AcceptedSVG />
          note = props.note
        } else {
          textContent = t('feedStatus.patientNotAccepted')
          svg = <DeclinedSVG />
          note = props.note
        }
      }
      break
    case 'etermin':
      if ('hasEtermin' in props) {
        if (props.hasEtermin) {
          textContent = t('feedStatus.patientEVisitAssigned')
          svg = <AcceptedSVG />
          note = props.note
        } else {
          textContent = t('feedStatus.patientEVisitNotAssigned')
          svg = <DeclinedSVG />
          note = props.note
        }
      }

      break
    case 'stepStart':
      textContent = t('feedStatus.patientAssignedToRunningPeriod')
      svg = <AcceptedSVG />
      break
    case 'stepEnd':
      textContent = t('feedStatus.patientCompletedRunningPeriod')
      svg = <AcceptedSVG />
      break
    default:
      break
  }

  return (
    <Card date={createdAt}>
      <FeedStatusSC>
        {svg}
        <p>{textContent}</p>
        {props.note && <NoteSC>"{note}"</NoteSC>}
      </FeedStatusSC>
    </Card>
  )
}

export default FeedStatus
